import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { forget } from "../../requests/auth";
import { createSignal } from "solid-js";
export default function useForgetPassword() {
  const [loading, setLoading] = createSignal(false);
  const [form, setForm] = createStore({
    identity: "",
  });

  const { successToast, errorToast } = useApplication();

  const onFormInput = (name, value) => {
    setForm(name, value);
  };

  const onSubmit = async (ev) => {
    ev.preventDefault();
    await onForgetPassword();
  }

  const onForgetPassword = async () => {
    setLoading(true);
    try {
      const response = await forget({
        ...form
      });

      successToast(response.message);
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    form,
    onForgetPassword,
    onSubmit,
    onFormInput,
  };
}
